export function mapSetPitch(pitch, options) { return this._animateCamera(pitch, this.getBearing(), options); }
